/* SEAGALE 360 — moteur des scènes au scroll.
   Une seule boucle rAF, valeurs lissées (inertie), aucun scroll détourné.
   Se réinitialise sur shopify:section:load. */
(function () {
  if (window.S360) { window.S360.scan(document); return; }
  document.documentElement.classList.add('s36-js');
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var clamp = function (x, a, b) { a = a === undefined ? 0 : a; b = b === undefined ? 1 : b; return Math.max(a, Math.min(b, x)); };
  var seg = function (t, a, b) { return clamp((t - a) / (b - a)); };
  var ease = function (x) { x = clamp(x); return x * x * (3 - 2 * x); };
  var easeOut = function (x) { x = clamp(x); return 1 - Math.pow(1 - x, 3); };
  var lerp = function (a, b, k) { return a + (b - a) * k; };
  var scenes = [];
  var running = false;
  var vh = window.innerHeight;

  function pinProgress(el) {
    var r = el.getBoundingClientRect();
    var span = r.height - vh;
    return span > 0 ? clamp(-r.top / span) : clamp((vh - r.top) / (vh + r.height));
  }
  function viewProgress(el) { // 0 quand le haut entre par le bas, 1 quand il atteint 10 % de l'écran
    var r = el.getBoundingClientRect();
    return clamp((vh - r.top) / (vh * 0.9));
  }
  function passProgress(el) { // 0 quand le haut entre par le bas, 1 quand le bas sort par le haut
    var r = el.getBoundingClientRect();
    return clamp((vh - r.top) / (vh + r.height));
  }
  function near(el) { var r = el.getBoundingClientRect(); return r.bottom > -vh * 0.5 && r.top < vh * 1.5; }

  function splitWords(el) {
    if (!el || el.getAttribute('data-split')) return [];
    var words = el.textContent.trim().split(/\s+/);
    el.innerHTML = words.map(function (w) { return '<span class="w">' + w + '</span>'; }).join(' ');
    el.setAttribute('data-split', '1');
    return [].slice.call(el.querySelectorAll('.w'));
  }
  function revealWords(list, k) { var n = list.length, on = Math.round(k * n); for (var i = 0; i < n; i++) list[i].classList.toggle('on', i < on); }
  function hex(c) { c = (c || '').trim(); if (c.charAt(0) !== '#') return null; if (c.length === 4) c = '#' + c[1] + c[1] + c[2] + c[2] + c[3] + c[3]; return [parseInt(c.substr(1, 2), 16), parseInt(c.substr(3, 2), 16), parseInt(c.substr(5, 2), 16)]; }
  function mix(a, b, k) { return 'rgb(' + Math.round(lerp(a[0], b[0], k)) + ',' + Math.round(lerp(a[1], b[1], k)) + ',' + Math.round(lerp(a[2], b[2], k)) + ')'; }
  var NAVY = [0, 4, 28], WHITE = [255, 255, 255];

  /* ---------- scènes ---------- */
  var BUILD = {};

  BUILD.hero = function (el) {
    var media = el.querySelector('.s36-hero-media'), txt = el.querySelector('.s36-hero-txt');
    var h1 = el.querySelector('h1');
    if (h1 && !h1.getAttribute('data-split')) {
      var t = h1.textContent.trim(); h1.setAttribute('aria-label', t); h1.setAttribute('data-split', '1');
      h1.innerHTML = t.split('').map(function (c, i) {
        return '<span class="clip" aria-hidden="true"><span class="ch" style="transition-delay:' + (i * 45) + 'ms">' + (c === ' ' ? '&nbsp;' : c) + '</span></span>';
      }).join('');
    }
    requestAnimationFrame(function () { el.classList.add('is-in'); });
    var v = el.querySelector('video'); if (v) { v.muted = true; var pp = v.play(); if (pp && pp.catch) pp.catch(function () {}); }
    return { el: el, raw: function (e) { var r = e.getBoundingClientRect(); return clamp(-r.top / (r.height || vh)); }, update: function (p) {
      if (media) { media.style.transform = 'scale(' + lerp(1, 0.9, p) + ')'; media.style.opacity = lerp(1, 0.35, p); }
      if (txt) { txt.style.transform = 'translateY(' + (-p * 90) + 'px)'; txt.style.opacity = 1 - seg(p, 0, 0.7); }
    } };
  };

  BUILD.dense = function (el) {
    var big = el.querySelector('[data-big]'), a = el.querySelector('.s36-dense-media .a'), b = el.querySelector('.s36-dense-media .b');
    var to = parseFloat(big ? big.getAttribute('data-to') : 360) || 360;
    var from = parseFloat(big ? big.getAttribute('data-from') : 300);
    if (isNaN(from)) from = Math.round(to * 0.83);
    return { el: el, update: function (p) {
      var k = easeOut(seg(p, 0, 0.3));
      if (big) big.textContent = Math.round(lerp(from, to, k));
      if (a) a.style.transform = 'translate3d(' + lerp(-30, 10, p) + 'px,' + lerp(120, -60, p) + 'px,0) rotate(' + lerp(-6, -2, p) + 'deg)';
      if (b) b.style.transform = 'translate3d(' + lerp(40, -10, p) + 'px,' + lerp(-100, 50, p) + 'px,0) rotate(' + lerp(5, 2, p) + 'deg)';
    } };
  };

  BUILD.cmp = function (el) {
    var frame = el.querySelector('.s36-cmp-frame'), range = el.querySelector('.s36-cmp-range');
    var A = el.querySelector('[data-side="a"]'), B = el.querySelector('[data-side="b"]');
    var manual = false, drag = false, x = 88;
    function set(v) {
      x = clamp(v, 0, 100); frame.style.setProperty('--x', x + '%');
      if (range) { range.value = Math.round(x); range.setAttribute('aria-valuetext', x > 50 ? 'Face extérieure' : 'Face intérieure'); }
      if (A) A.classList.toggle('dim', x < 50);
      if (B) B.classList.toggle('dim', x >= 50);
    }
    function fromEvent(e) { var r = frame.getBoundingClientRect(); set((e.clientX - r.left) / r.width * 100); }
    frame.addEventListener('pointerdown', function (e) { manual = true; drag = true; if (frame.setPointerCapture) frame.setPointerCapture(e.pointerId); fromEvent(e); });
    frame.addEventListener('pointermove', function (e) { if (drag) fromEvent(e); });
    ['pointerup', 'pointercancel'].forEach(function (t) { frame.addEventListener(t, function () { drag = false; }); });
    if (range) range.addEventListener('input', function () { manual = true; set(parseFloat(range.value)); });
    set(RM ? 50 : 88);
    return { el: el, raw: passProgress, update: function (p) {
      if (manual || RM) return;
      set(lerp(88, 12, ease(seg(p, 0.3, 0.62))));
    } };
  };

  BUILD.duo = function (el) {
    var figs = [].slice.call(el.querySelectorAll('figure'));
    return { el: el, raw: viewProgress, update: function (p) {
      figs.forEach(function (f, i) {
        var k = easeOut(seg(p, i * 0.08, 0.5 + i * 0.08));
        f.style.clipPath = 'inset(' + ((1 - k) * 100) + '% 0 0 0)';
        var im = f.querySelector('img'); if (im) im.style.transform = 'scale(' + lerp(1.12, 1, k) + ')';
      });
    } };
  };

  BUILD.fib = function (el) {
    var m = el.querySelector('.s36-fib-media'), words = splitWords(el.querySelector('[data-words]')), lead = el.querySelector('.s36-lead');
    return { el: el, update: function (p) {
      if (m) m.style.transform = 'scale(' + lerp(1.35, 1, ease(p)) + ') rotate(' + lerp(-3, 0, p) + 'deg)';
      revealWords(words, seg(p, 0.05, 0.32));
      if (lead) { var k = seg(p, 0.3, 0.38); lead.style.opacity = k; lead.style.transform = 'translateY(' + ((1 - k) * 14) + 'px)'; }
    } };
  };

  BUILD.day = function (el) {
    var night = el.querySelector('.night'), line = el.querySelector('.s36-day-line');
    var mi = el.querySelector('.morning img'), ni = el.querySelector('.night img');
    var tm = el.querySelector('.s36-day-t.m'), ts = el.querySelector('.s36-day-t.s');
    return { el: el, update: function (p) {
      var w = ease(seg(p, 0.3, 0.72));
      if (night) night.style.clipPath = 'inset(0 0 0 ' + ((1 - w) * 100) + '%)';
      if (line) { line.style.left = ((1 - w) * 100) + '%'; line.style.opacity = w > 0.001 && w < 0.999 ? 1 : 0; }
      if (mi) mi.style.transform = 'scale(' + lerp(1.12, 1.02, seg(p, 0, 0.5)) + ')';
      if (ni) ni.style.transform = 'scale(' + lerp(1.12, 1.02, seg(p, 0.4, 1)) + ')';
      if (tm) { var a = 1 - seg(p, 0.32, 0.5); tm.style.opacity = a; tm.style.transform = 'translateX(' + (-(1 - a) * 40) + 'px)'; }
      if (ts) { var b = seg(p, 0.58, 0.76); ts.style.opacity = b; ts.style.transform = 'translateX(' + ((1 - b) * 40) + 'px)'; }
    } };
  };

  BUILD.turn = function (el) {
    var cv = el.querySelector('canvas'), ctx = cv.getContext('2d'), poster = el.querySelector('.s36-turn-load');
    var base = el.getAttribute('data-base') || '', n = parseInt(el.getAttribute('data-frames') || '48', 10), ext = el.getAttribute('data-ext') || 'webp';
    var bar = el.querySelector('.bar i'), deg = el.querySelector('[data-deg]');
    var head = el.querySelector('.s36-turn-head .s36-h2'), dial = el.querySelector('.s36-turn-dial');
    var ghost = hex(getComputedStyle(el).getPropertyValue('--ghost')) || [234, 234, 236];
    var imgs = [], started = false, cur = -1, lastP = 0, off = 0, drag = null, lastBg = -1;
    function src(i) { var s = String(i + 1); while (s.length < 2) s = '0' + s; return base + s + '.' + ext; }
    function load() {
      if (started || !base) return; started = true;
      for (var i = 0; i < n; i++) (function (i) {
        var im = new Image(); im.decoding = 'async';
        im.onload = function () { if (i === 0 && cur < 0) { fit(im); paint(im); cur = 0; } };
        im.src = src(i); imgs[i] = im;
      })(i);
    }
    function fit(im) { cv.width = im.naturalWidth; cv.height = im.naturalHeight; }
    function paint(im) { ctx.clearRect(0, 0, cv.width, cv.height); ctx.drawImage(im, 0, 0, cv.width, cv.height); if (poster) poster.style.opacity = 0; }
    function draw() {
      var k = seg(lastP, 0.06, 0.94), pos = k * (n - 1) + off;
      var f = ((Math.round(pos) % n) + n) % n;
      var turn = ((pos / n) % 1 + 1) % 1;
      if (bar) bar.style.transform = 'scaleX(' + (Math.abs(off) > 0.5 ? turn : k) + ')';
      if (deg) deg.textContent = Math.round((Math.abs(off) > 0.5 ? turn : k) * 360) + '°';
      if (f === cur) return;
      var im = imgs[f];
      if (im && im.complete && im.naturalWidth) { if (cv.width !== im.naturalWidth) fit(im); paint(im); cur = f; }
    }
    cv.addEventListener('pointerdown', function (e) { load(); drag = { x: e.clientX, o: off }; if (cv.setPointerCapture) cv.setPointerCapture(e.pointerId); });
    if (!cv.hasAttribute('tabindex')) cv.setAttribute('tabindex', '0');
    cv.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); load(); off += (e.key === 'ArrowRight' ? 1 : -1); draw(); } });
    cv.addEventListener('pointermove', function (e) { if (!drag) return; off = drag.o + (e.clientX - drag.x) / Math.max(cv.clientWidth, 1) * n * 0.9; draw(); });
    ['pointerup', 'pointercancel'].forEach(function (t) { cv.addEventListener(t, function () { drag = null; }); });
    return { el: el, prefetch: load, update: function (p) {
      lastP = p;
      // fondu du fond navy vers le gris du studio pendant l'entrée de la section
      var r = el.getBoundingClientRect(), e = RM ? 1 : ease(clamp((vh - r.top) / (vh * 0.7)));
      if (Math.abs(e - lastBg) > 0.002) {
        lastBg = e; el.style.background = mix(NAVY, ghost, e);
        var tc = mix(WHITE, NAVY, e);
        if (head) head.style.color = tc;
        if (dial) dial.style.color = tc;
      }
      draw();
    } };
  };

  /* film en lecture automatique : <video> muette en boucle, légendes calées sur currentTime */
  BUILD.filmAuto = function (el) {
    var v = el.querySelector('video'), mq = window.matchMedia('(max-width: 820px)');
    var fps = parseFloat(el.getAttribute('data-fps')) || 30, n = parseInt(el.getAttribute('data-frames'), 10) || 234;
    var ov = el.querySelector('.s36-film-ov'), ST = null, CAPS = [], lastTxt = '', lastF = -1;
    var oCap = ov && ov.querySelector('.cap'), oCapK = oCap && oCap.querySelector('.k'), oCapS = oCap && oCap.querySelector('.s');
    var oLabs = ov ? [].slice.call(ov.querySelectorAll('.lab')) : [], oEnd = ov && ov.querySelector('.end');
    if (ov) {
      try { var cj = JSON.parse((ov.querySelector('.s36-film-caps') || {}).textContent || '[]'); for (var c = 0; c + 1 < cj.length; c += 2) CAPS.push([cj[c], cj[c + 1]]); } catch (e) {}
      var su = el.getAttribute('data-states');
      if (su && window.fetch) fetch(su).then(function (r) { return r.json(); }).then(function (j) { ST = j; lastF = -1; }).catch(function () {});
    }
    function src() { var m = mq.matches && el.getAttribute('data-video-m'); return m || el.getAttribute('data-video'); }
    function setSrc() { var s = src(); if (v && s && v.getAttribute('src') !== s) { v.setAttribute('src', s); v.load(); var p = v.play(); if (p && p.catch) p.catch(function () {}); } }
    function box() { // rectangle réellement occupé par la vidéo (object-fit: contain)
      var W = v.clientWidth, H = v.clientHeight, vw = v.videoWidth || 16, vh2 = v.videoHeight || 9;
      var r = Math.min(W / vw, H / vh2), w = vw * r, h = vh2 * r; return [(W - w) / 2, (H - h) / 2, w, h];
    }
    function overlay(f) {
      if (!ov || !ST || !v.videoWidth) return;
      var port = mq.matches && el.getAttribute('data-video-m'), S = port ? ST.m : ST.d; if (!S) return;
      var b = box(), s = S[Math.min(f, S.length - 1)], RW = port ? ST.mw : ST.dw;
      ov.classList.toggle('port', !!port);
      ov.style.left = b[0] + 'px'; ov.style.top = b[1] + 'px'; ov.style.width = b[2] + 'px'; ov.style.height = b[3] + 'px'; ov.style.fontSize = (b[2] / RW) + 'px';
      var ci = s.cap[0], ca = s.cap[1];
      if (oCap) {
        var tx = CAPS[ci] || ['', ''];
        if (ci >= 0 && lastTxt !== ci + ':' + tx[0]) { oCapK.textContent = tx[0]; oCapS.textContent = tx[1]; lastTxt = ci + ':' + tx[0]; }
        var dy = (1 - easeOut(s.cap[1])) * 14;
        oCap.style.opacity = ci >= 0 ? ca : 0;
        oCap.style.transform = port ? 'translateY(' + dy + 'em)' : 'translateY(calc(-50% + ' + dy + 'em))';
      }
      oLabs.forEach(function (o, i) { var l = s.labs[i] || [0, 0, 0]; o.style.opacity = l[2]; if (l[2] > 0) { o.style.left = (l[0] * 100) + '%'; o.style.top = (l[1] * 100) + '%'; } });
      if (oEnd) oEnd.style.opacity = s.end;
    }
    function loop() {
      if (v && !v.paused) { var f = Math.min(n - 1, Math.floor(v.currentTime * fps)); if (f !== lastF || lastF < 0) { lastF = f; overlay(f); } }
      requestAnimationFrame(loop);
    }
    // plein écran sous l'en-tête : la section prend exactement la hauteur restante du premier écran
    function fit() { var top = el.getBoundingClientRect().top + window.pageYOffset; if (top >= 0 && top < 240) el.style.height = Math.max(320, window.innerHeight - top) + 'px'; }
    if (v) {
      fit(); window.addEventListener('resize', fit); window.addEventListener('orientationchange', fit);
      setSrc();
      if (mq.addEventListener) mq.addEventListener('change', setSrc);
      v.addEventListener('loadedmetadata', function () { lastF = -1; });
      // relance si le navigateur a bloqué l'autoplay (économie d'énergie) : premier geste
      ['touchstart', 'pointerdown', 'keydown'].forEach(function (t) { window.addEventListener(t, function () { if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } }, { once: true, passive: true }); });
      requestAnimationFrame(loop);
    }
    return { el: el, raw: function () { return 0; }, update: function () {} };
  };

  BUILD.film = function (el) {
    if (el.getAttribute('data-mode') === 'auto') return BUILD.filmAuto(el);
    var cv = el.querySelector('canvas'), ctx = cv.getContext('2d'), poster = el.querySelector('.s36-film-poster'), cue = el.querySelector('.s36-film-cue');
    var mq = window.matchMedia('(max-width: 820px)');
    var set, sheets, cur = '', started = false;
    var G = parseInt(el.getAttribute('data-grid') || '3', 10), PER = G * G;
    var intro = el.getAttribute('data-intro') === '1', HOLD = intro ? 0.08 : 0;
    // textes réels posés sur le film : positions enregistrées image par image au rendu
    var ov = el.querySelector('.s36-film-ov'), ST = null, CAPS = [], box = null, lastTxt = '';
    var oCap = ov && ov.querySelector('.cap'), oCapK = oCap && oCap.querySelector('.k'), oCapS = oCap && oCap.querySelector('.s');
    var oLabs = ov ? [].slice.call(ov.querySelectorAll('.lab')) : [], oEnd = ov && ov.querySelector('.end');
    if (ov) {
      try { var cj = JSON.parse((ov.querySelector('.s36-film-caps') || {}).textContent || '[]'); for (var c = 0; c + 1 < cj.length; c += 2) CAPS.push([cj[c], cj[c + 1]]); } catch (e) {}
      var su = el.getAttribute('data-states');
      if (su && window.fetch) fetch(su).then(function (r) { return r.json(); }).then(function (j) { ST = j; cur = ''; kick(); }).catch(function () {});
    }
    function overlay(f, veil) {
      if (!ov || !ST || !box) return;
      var port = mq.matches && el.getAttribute('data-base-m'), S = port ? ST.m : ST.d; if (!S) return;
      var s = S[Math.min(f, S.length - 1)], k = 1 - veil, RW = port ? ST.mw : ST.dw;
      ov.classList.toggle('port', !!port);
      ov.style.left = box[0] + 'px'; ov.style.top = box[1] + 'px'; ov.style.width = box[2] + 'px'; ov.style.height = box[3] + 'px'; ov.style.fontSize = (box[2] / RW) + 'px';
      var ci = s.cap[0], ca = s.cap[1] * k;
      if (oCap) {
        var tx = CAPS[ci] || ['', ''];
        if (ci >= 0 && lastTxt !== ci + ':' + tx[0]) { oCapK.textContent = tx[0]; oCapS.textContent = tx[1]; lastTxt = ci + ':' + tx[0]; }
        var dy = (1 - easeOut(s.cap[1])) * 14;
        oCap.style.opacity = ci >= 0 ? ca : 0;
        oCap.style.transform = port ? 'translateY(' + dy + 'em)' : 'translateY(calc(-50% + ' + dy + 'em))';
      }
      oLabs.forEach(function (o, i) { var l = s.labs[i] || [0, 0, 0]; o.style.opacity = l[2] * k; if (l[2] > 0) { o.style.left = (l[0] * 100) + '%'; o.style.top = (l[1] * 100) + '%'; } });
      if (oEnd) oEnd.style.opacity = s.end * k;
    }
    function cfg() {
      var m = mq.matches && el.getAttribute('data-base-m');
      var n = parseInt(m ? el.getAttribute('data-frames-m') : el.getAttribute('data-frames'), 10) || 234;
      var fi = parseInt(el.getAttribute('data-intro-frame') || '', 10);
      return { base: m ? el.getAttribute('data-base-m') : el.getAttribute('data-base'), n: n, ns: Math.ceil(n / PER), ext: el.getAttribute('data-ext') || 'jpg',
        fi: isNaN(fi) ? n - 3 : clamp(fi - 1, 0, n - 1) };
    }
    function src(i) { var s = String(i + 1); while (s.length < 2) s = '0' + s; return set.base + s + '.' + set.ext; }
    function size() { var dpr = Math.min(window.devicePixelRatio || 1, 2); cv.width = Math.round(cv.clientWidth * dpr); cv.height = Math.round(cv.clientHeight * dpr); cur = ''; }
    function reset() { set = cfg(); sheets = new Array(set.ns); started = false; cur = ''; }
    var introDone = false, armed = false;
    function fetchSheet(i, done) {
      if (sheets[i] || sheets[i] === false) { if (done) done(); return; }
      sheets[i] = false; // en cours
      var im = new Image(); im.decoding = 'async';
      im.onload = im.onerror = function () { sheets[i] = im.naturalWidth ? im : undefined; cur = ''; kick(); if (done) done(); };
      im.src = src(i);
    }
    // 1. la planche de l'image d'ouverture, seule, tout de suite (≈ 180 ko)
    function loadIntro() {
      if (introDone || !set.base || !intro) return; introDone = true;
      fetchSheet(Math.floor(set.fi / PER));
    }
    // 2. tout le film, dans l'ordre, 3 planches à la fois : seulement après window.load
    //    ou au premier geste de l'utilisateur, jamais avant (sinon l'événement load attend 10 Mo d'images)
    function load() {
      if (started || !set.base) return;
      if (!armed) { arm(); return; }
      started = true;
      var order = [], i;
      if (intro) order.push(Math.floor(set.fi / PER));
      for (i = 0; i < set.ns; i++) if (order.indexOf(i) < 0) order.push(i);
      var k = 0, active = 0;
      function next() {
        while (active < 3 && k < order.length) {
          var i = order[k++];
          if (sheets[i]) continue;
          active++; fetchSheet(i, function () { active--; next(); });
        }
      }
      next();
    }
    function arm() {
      if (armed) return;
      var go = function () { if (armed) return; armed = true; load(); };
      if (document.readyState === 'complete') { setTimeout(go, 150); return; }
      window.addEventListener('load', function () { setTimeout(go, 150); }, { once: true });
      ['wheel', 'touchstart', 'keydown', 'pointerdown'].forEach(function (t) { window.addEventListener(t, go, { once: true, passive: true }); });
    }
    function frame(f) { // renvoie [sheet, index] de l'image chargée la plus proche
      var si = Math.floor(f / PER);
      if (sheets[si]) return [sheets[si], f % PER, true];
      for (var d = 1; d < set.ns; d++) { if (sheets[si - d]) return [sheets[si - d], PER - 1]; if (sheets[si + d]) return [sheets[si + d], 0]; }
      return null;
    }
    function paint(fr, veil) {
      var im = fr[0], j = fr[1], fw = im.naturalWidth / G, fh = im.naturalHeight / G, sx = (j % G) * fw, sy = Math.floor(j / G) * fh;
      ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.fillStyle = '#00041c'; ctx.fillRect(0, 0, cv.width, cv.height);
      var r = Math.min(cv.width / fw, cv.height / fh), w = fw * r, h = fh * r;
      ctx.drawImage(im, sx, sy, fw, fh, (cv.width - w) / 2, (cv.height - h) / 2, w, h);
      var d = cv.width / (cv.clientWidth || 1); box = [(cv.width - w) / 2 / d, (cv.height - h) / 2 / d, w / d, h / d];
      if (veil > 0) { ctx.globalAlpha = veil; ctx.fillRect(0, 0, cv.width, cv.height); ctx.globalAlpha = 1; }
      if (poster) poster.style.opacity = 0;
    }
    reset(); size();
    if (intro) loadIntro();
    arm();
    if (mq.addEventListener) mq.addEventListener('change', function () { reset(); introDone = false; loadIntro(); started = false; load(); });
    return { el: el, prefetch: load, resize: size, update: function (p) {
      if (cue) cue.style.opacity = 1 - seg(p, 0, 0.025);
      var f, veil = 0;
      if (intro && p < HOLD) {
        // l'image finale ouvre la page, puis s'efface vers le navy avant le début du film
        f = set.fi; veil = seg(p, HOLD * 0.35, HOLD);
      } else {
        var k = seg(p, HOLD, 0.97); f = Math.min(set.n - 1, Math.round(k * (set.n - 1)));
        if (intro) veil = 1 - seg(p, HOLD, HOLD + 0.03);
      }
      var key = f + ':' + Math.round(veil * 40) + (ST ? 's' : '');
      if (key === cur) return;
      var fr = frame(f); if (!fr) return;
      paint(fr, veil); overlay(f, veil); if (fr[2]) cur = key;
    } };
  };

  /* ---------- sommaire et bouton collant ---------- */
  var toc = null, tocLinks = [], chaps = [], sticky = null, film = null, cards = null;
  function buildToc() {
    chaps = [].slice.call(document.querySelectorAll('.s36[data-chap]')).filter(function (s) { return s.getAttribute('data-chap'); });
    if (toc) { toc.parentNode.removeChild(toc); toc = null; }
    if (chaps.length < 2) return;
    toc = document.createElement('nav'); toc.className = 's36-toc'; toc.setAttribute('aria-label', 'Chapitres de la page');
    tocLinks = chaps.map(function (s) {
      var a = document.createElement('a'); a.href = '#' + s.id; a.innerHTML = '<i></i><b>' + s.getAttribute('data-chap') + '</b>'; a.setAttribute('aria-label', s.getAttribute('data-chap'));
      a.addEventListener('click', function (e) { e.preventDefault(); window.scrollTo({ top: s.getBoundingClientRect().top + window.pageYOffset, behavior: RM ? 'auto' : 'smooth' }); });
      toc.appendChild(a); return a;
    });
    document.body.appendChild(toc);
  }
  function chrome() {
    if (toc) {
      var act = -1;
      chaps.forEach(function (s, i) { if (s.getBoundingClientRect().top <= vh * 0.5) act = i; });
      var last = chaps[chaps.length - 1].getBoundingClientRect();
      var show = act >= 1 && last.bottom > vh * 0.5;
      toc.classList.toggle('on', show);
      tocLinks.forEach(function (a, i) { a.classList.toggle('on', i === act); });
    }
    if (sticky) {
      var fb = film ? film.getBoundingClientRect().bottom : 0;
      var ct = cards ? cards.getBoundingClientRect().top : 1e9;
      sticky.classList.toggle('on', fb < vh * 0.4 && ct > vh * 0.85);
    }
  }

  /* ---------- boucle ---------- */
  function scan(root) {
    [].forEach.call(root.querySelectorAll('[data-s36]'), function (el) {
      if (el.getAttribute('data-s36-init')) return;
      var b = BUILD[el.getAttribute('data-s36')]; if (!b) return;
      el.setAttribute('data-s36-init', '1');
      var s = b(el); s.p = s.raw ? s.raw(el) : pinProgress(el); s.sp = s.p;
      s.update(RM ? (el.getAttribute('data-s36') === 'turn' || el.getAttribute('data-s36') === 'film' ? 0 : 1) : s.sp);
      scenes.push(s);
    });
    [].forEach.call(root.querySelectorAll('.s36-rv'), function (el) { if (io) io.observe(el); });
    sticky = document.querySelector('.s36-sticky'); film = document.querySelector('.s36-film'); cards = document.querySelector('.s36-turn') || document.querySelector('.s36-cards');
    buildToc(); chrome();
    kick();
  }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -15% 0px' }) : null;
  if (!io) document.documentElement.classList.add('s36-js-off');

  function tick() {
    var moving = false;
    scenes = scenes.filter(function (s) { return document.body.contains(s.el); });
    scenes.forEach(function (s) {
      if (!near(s.el)) return;
      if (s.prefetch) s.prefetch();
      s.p = s.raw ? s.raw(s.el) : pinProgress(s.el);
      if (RM) { s.sp = s.p; } else { s.sp += (s.p - s.sp) * 0.14; }
      if (Math.abs(s.p - s.sp) > 0.0006) moving = true; else s.sp = s.p;
      s.update(s.sp);
    });
    chrome();
    if (moving) requestAnimationFrame(tick); else running = false;
  }
  function kick() { if (!running) { running = true; requestAnimationFrame(tick); } }
  window.addEventListener('scroll', kick, { passive: true });
  window.addEventListener('resize', function () { vh = window.innerHeight; scenes.forEach(function (s) { if (s.resize) s.resize(); }); kick(); });
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  document.addEventListener('shopify:section:unload', function () { setTimeout(function () { buildToc(); kick(); }, 50); });

  window.S360 = { scan: scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); }); else scan(document);
})();
